import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchCustomScreenTypes = getApiActionTypes('CUSTOM_SCREEN/FETCH_CUSTOM_SCREEN');
export const updateCustomScreenTypes = getApiActionTypes('CUSTOM_SCREEN/UPDATE_CUSTOM_SCREEN');
